import React from "react";
import ReportCategoryCard from "./ReportCategoryCard";
import type {
  ReportCategoryMeta,
  ReportCatalogEntry,
} from "../constants/report-catalog";
import styles from "./ReportCategorySection.module.scss";

interface ReportCategorySectionProps {
  category: ReportCategoryMeta;
  reports: ReportCatalogEntry[];
}

const ReportCategorySection: React.FC<ReportCategorySectionProps> = ({
  category,
  reports,
}) => {
  if (reports.length === 0) return null;
  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <span className={styles.orderBadge}>{category.order}</span>
        <div className={styles.headerBody}>
          <h3 className={styles.title}>{category.title}</h3>
          <p className={styles.subtitle}>{category.description}</p>
        </div>
        <span className={styles.countBadge}>
          {reports.length} rapor
        </span>
      </div>
      <div className={styles.grid}>
        {reports.map((r) => (
          <ReportCategoryCard key={r.key} report={r} />
        ))}
      </div>
    </section>
  );
};

export default ReportCategorySection;
